import { Layer } from './layer';
import { TopLevelLayers } from './top-level-layers';
export interface LayerSelectors{
  pointer:boolean,
  polygon:boolean,
  circle:boolean

}

export class ParentLayers{
  active:boolean = false;
  name:string = '';
  childLayers : TopLevelLayers[];
  visible: boolean;
  layersSelector:LayerSelectors = {
    pointer:false,
    polygon:false,
    circle:false
  }


  constructor(active:boolean, name:string, childLayers:TopLevelLayers[],visible?:boolean) {
    this.active = active;
    this.name = name;
    this.childLayers = childLayers;
    this.visible = visible;
  }

  layersTabTrigger():void {
    this.active = !this.active;

  }
  clicked(layer:any):void{
    console.log();
    if(layer instanceof TopLevelLayers) {
      if(layer.allVisible()){
        layer.clicked();
      }
    }
  }

  onSelect(layer:any): void{
    if(layer instanceof TopLevelLayers) {
      let visible = !layer.allVisible();

      if(visible){
        layer.showAll();
      }
      else{
        layer.hideAll();
      }
    }
    else{
      layer.visible = !layer.visible;
      layer.olLayer.setVisible(layer.visible);
    }
  }

  onSelectPerformance(layer:any): void{
    if(layer instanceof TopLevelLayers) {
      let visible = !layer.oneVisible();

      if(visible){
        layer.showAll();
      }
      else{
        layer.hideAll();
      }
    }
    else{
      layer.visible = !layer.visible;
      layer.olLayer.setVisible(layer.visible);
    }
  }

   onSelectDocSectorization(layer:any,navaid:String): void{
    if(layer instanceof TopLevelLayers) {
      layer.onSelectDocSectorization(navaid);
    }
  }

  clickEvent(layer:any):void {
    if(layer instanceof TopLevelLayers) {
      layer.status = !layer.status;
    }
  }

  clickLayerEvent(layer:Layer):void {

      layer.expanded = !layer.expanded;

  }

  displayLegend(navaid_name:string, layer:Layer):void {
    if(layer instanceof TopLevelLayers) {
      layer.displayLegend(navaid_name);
    }
  }

  deleteLayer(layer : TopLevelLayers){
    layer.hideAll();
    layer.layers.forEach(x => {x.olLayer.setVisible(false)});
    const indexes = this.childLayers
      .map((x, i) => x.name === layer.name ? i : -1)
      .filter(index => index !== -1);
    if (indexes.length == 0) {
      return;
    }

    if (indexes.length == 1) {
      this.childLayers.splice(indexes[0], 1);
      return;
    }

    if (indexes.length > 1) {
      const indexOf = this.childLayers.indexOf(layer);
      if (indexOf == -1) {
        this.childLayers.splice(indexes[0], 1);
        return;
      }

      this.childLayers.splice(indexOf, 1);
    }
  }

  selectChild(child : TopLevelLayers){
    child.active = !child.active;
    child.layers.forEach(layer => {
      layer.visible = child.active;
      layer.olLayer.setVisible(child.active);
    });
  }

  allLayersVisible(){
    for (const layer of this.childLayers){
      if (!layer.allVisible()){
        return false
      }
    }
    return true;
  }
  
}
